import { LayoutGrid, Activity, Wallet, Gauge, Layers, ShieldCheck, BarChart3, LineChart, Send } from "lucide-react";

const A = "https://alpha.tradrquant.com";

export const FREE_TOOLS = [
  { id: "flow-cells", t: "Flow Cells", d: "Live whale rotation map · new", href: A + "/flow-cells", Icon: LayoutGrid },
  { id: "terminal", t: "Order flow terminal", d: "Footprint, Smart Tape, CVD · BTC & ETH", href: A + "/terminal", Icon: BarChart3 },
  { id: "alpha", t: "Alpha Flow", d: "Live taker tape & aggression", href: A, Icon: Gauge },
  { id: "pulse", t: "TQ Pulse", d: "Volatility before the breakout", href: A + "/screener", Icon: Activity },
  { id: "whales", t: "Whale Radar", d: "Tracked Hyperliquid positions", href: A + "/whales", Icon: Wallet },
  { id: "regime", t: "TQ Regime", d: "Seven-state market engine", href: A + "/tq-regime", Icon: Layers },
  { id: "verify", t: "Verify", d: "Every setup, published & resolved", href: "https://verify.tradrquant.com", Icon: ShieldCheck },
  { id: "indicator", t: "TradingView indicator", d: "TradrQuant Pro, free on TradingView", href: "https://www.tradingview.com/script/MiXDrieo-TradrQuant-Pro/", Icon: LineChart },
  { id: "telegram", t: "Telegram alerts", d: "Whale & setup alerts, free", href: "https://t.me/TradrQuantRadar", Icon: Send },
];
